module.exports = __webpack_public_path__ + "img/a6df085.png";